import React from 'react';
import { MessageCircle } from 'lucide-react';

const WATERMARK_BG = 'https://images.unsplash.com/photo-1518495973542-4542c06a5843?auto=format&fit=crop&w=2400&q=80';

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-[90vh] flex items-center bg-[#FAF9F6] overflow-hidden pt-24"
      data-testid="hero-section"
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-60 pointer-events-none"
        style={{ backgroundImage: `url(${WATERMARK_BG})` }}
        aria-hidden="true"
      />
      {/* Mobile-first solid wash (keeps text readable on small screens) */}
      <div className="absolute inset-0 bg-[#FAF9F6]/85 lg:hidden pointer-events-none" aria-hidden="true" />
      {/* Desktop horizontal fade reveals the image on the right */}
      <div
        className="absolute inset-0 pointer-events-none hidden lg:block"
        style={{ backgroundImage: 'linear-gradient(90deg, rgba(250,249,246,0.96) 0%, rgba(250,249,246,0.88) 40%, rgba(250,249,246,0.55) 85%, rgba(250,249,246,0.35) 100%)' }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#FAF9F6]/40 via-transparent to-[#FAF9F6]/70 pointer-events-none" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="max-w-2xl">
          <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl text-[#2C362A] leading-tight tracking-tight mb-8 fade-in fade-in-delay-2">
            Welcome
          </h2>

          <div className="font-body text-base md:text-lg text-[#5B6E56] leading-relaxed space-y-4 mb-10 fade-in fade-in-delay-3">
            <p>
              You might be here because something in your life feels difficult to manage, perhaps you're overwhelmed, stuck, or finding it hard to keep going as you have been. Reaching out can feel like a big step, especially when things are already heavy, but it can also mark the beginning of meaningful change.
            </p>
            <p>
              Therapy offers you time and space to slow things down, talk openly, and begin to understand what's going on for you in a clearer, more manageable way. It can help you make sense of your thoughts and feelings, work through what's been weighing on you, and find a way forward that fits what you need.
            </p>
            <p>
              If you're considering taking that step, please reach out whenever you're ready.
            </p>
          </div>

          <div className="fade-in fade-in-delay-4">
            <button
              onClick={() => scrollTo('#contact')}
              className="inline-flex items-center justify-center gap-2 bg-[#708A72] text-white font-body font-medium text-sm px-8 py-3.5 rounded-full hover:bg-[#5D755F] hover:-translate-y-0.5 hover:shadow-lg transition-all duration-300"
              data-testid="hero-contact-btn"
            >
              <MessageCircle size={16} strokeWidth={1.5} />
              Get in Touch
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#FAF9F6] to-transparent pointer-events-none" aria-hidden="true" />
    </section>
  );
}
